import { render } from "./TileViewTemplateSetting.vue?vue&type=template&id=2b8904e9"
import script from "./TileViewTemplateSetting.vue?vue&type=script&lang=js"
export * from "./TileViewTemplateSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__